// ─────────────────────────────────────────────
//  Analytics — rating trends, platform breakdown, top tags
// ─────────────────────────────────────────────

const MONTHS   = ["Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar"];
const RATINGS  = [4.2, 4.3, 4.5, 4.4, 4.6, 4.7, 4.8, 4.7];
const PLATFORM_DATA = [
  { name: "Google",      color: "#4285F4", count: 68 },
  { name: "Yelp",        color: "#D32323", count: 41 },
  { name: "TripAdvisor", color: "#00AF87", count: 34 },
];
const TOP_TAGS = [
  ["Delicious food", 47],
  ["Great service",  38],
  ["Cozy atmosphere",29],
  ["Great value",    24],
  ["Would recommend",21],
  ["Friendly staff", 18],
];

export default function Analytics() {
  const maxRating = Math.max(...RATINGS);
  const minRating = Math.min(...RATINGS);
  const total     = PLATFORM_DATA.reduce((a, p) => a + p.count, 0);

  return (
    <div>
      <h1 style={{ margin: "0 0 24px", fontSize: 26, fontWeight: 900, letterSpacing: "-0.03em" }}>
        Analytics
      </h1>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>

        {/* Rating trend */}
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 14, padding: 20 }}>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", marginBottom: 14, letterSpacing: "0.1em" }}>
            RATING TREND
          </div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 80 }}>
            {RATINGS.map((v, i) => {
              const pct = ((v - minRating + 0.2) / (maxRating - minRating + 0.4)) * 100;
              return (
                <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                  <div
                    style={{
                      width: "100%",
                      background: `rgba(255,190,11,${0.3 + ((v - 4) * 0.4)})`,
                      borderRadius: "4px 4px 0 0",
                      height: `${pct}%`,
                      minHeight: 8,
                      transition: "height 0.4s ease",
                    }}
                  />
                  <div style={{ fontSize: 8, color: "rgba(255,255,255,0.2)" }}>{MONTHS[i]}</div>
                </div>
              );
            })}
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 12 }}>
            Avg: <span style={{ color: "#FFBE0B", fontWeight: 700 }}>
              {(RATINGS.reduce((a,v) => a+v, 0) / RATINGS.length).toFixed(1)}★
            </span> over last 8 months
          </div>
        </div>

        {/* Platform breakdown */}
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 14, padding: 20 }}>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", marginBottom: 14, letterSpacing: "0.1em" }}>
            BY PLATFORM
          </div>
          {PLATFORM_DATA.map((p) => (
            <div key={p.name} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <span style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>{p.name}</span>
                <span style={{ fontSize: 12, color: p.color, fontWeight: 700 }}>{p.count} reviews</span>
              </div>
              <div style={{ height: 7, background: "rgba(255,255,255,0.06)", borderRadius: 4 }}>
                <div style={{ height: "100%", width: `${(p.count / total) * 100}%`, background: p.color, borderRadius: 4 }} />
              </div>
            </div>
          ))}
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 8 }}>
            {total} total reviews across {PLATFORM_DATA.length} platforms
          </div>
        </div>
      </div>

      {/* Top tags */}
      <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 14, padding: 20 }}>
        <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", marginBottom: 14, letterSpacing: "0.1em" }}>
          TOP TAGS FROM CUSTOMERS
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {TOP_TAGS.map(([tag, n]) => (
            <div
              key={tag}
              style={{
                padding: "8px 14px", borderRadius: 20,
                background: "rgba(255,190,11,0.1)",
                border: "1px solid rgba(255,190,11,0.2)",
                display: "flex", gap: 8, alignItems: "center",
              }}
            >
              <span style={{ fontSize: 13, color: "#f0ede8" }}>{tag}</span>
              <span style={{ fontSize: 11, fontWeight: 800, color: "#FFBE0B" }}>{n}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
